export function authHeader() {
    // return authorization header with jwt token
    let user = JSON.parse(localStorage.getItem('user'));

    if (user && user.data && user.data.message) {
        return { 'Authorization': 'Bearer ' + user.data.message };
    } else {
        return {};
    }
}